import { render } from "./BtnAComponent.vue?vue&type=template&id=29cda8df&scoped=true"
import script from "./BtnAComponent.vue?vue&type=script&lang=js"
export * from "./BtnAComponent.vue?vue&type=script&lang=js"

import "./BtnAComponent.vue?vue&type=style&index=0&id=29cda8df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cda8df"]])

export default __exports__